export default __webpack_public_path__ + "static/media/mobile_login_background.63784b62.png";